<ng-container *ngIf='messages && messages.length > 0'>
  <app-message-viewer
    *ngFor='let message of messages'
    [asPlainText]='false'
    [message]='message'
    [sessionData]='sessionData'></app-message-viewer>
</ng-container>
